import { Link } from 'react-router-dom';
import { Button } from '../../../shared/components/Button';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageContainer } from '../../../shared/components/PageContainer';
import { useToast } from '../../../shared/components/Toast';
import { formatBrasilia } from '../../../shared/lib/date';
import { mensagemDeErro } from '../api';
import { formatDate } from '../components/format';
import { useAprovarMovimentacao, usePendentesAprovacao } from '../hooks/vidaFuncional';

const formatCurrency = (value: unknown) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value));

/** Movimentações aguardando aprovação (retroativo salarial, RN-GP-001-041). Quem registrou não aprova. */
export default function AprovacoesMovimentacaoPage() {
  const toast = useToast();
  const pendentes = usePendentesAprovacao();
  const aprovar = useAprovarMovimentacao();

  async function aprovarUma(id: string) {
    try {
      await aprovar.mutateAsync(id);
      toast.success('Movimentação aprovada e efetivada.');
    } catch (err) {
      toast.error(mensagemDeErro(err, 'Não foi possível aprovar a movimentação.'));
    }
  }

  const lista = pendentes.data ?? [];
  return (
    <PageContainer
      title="Aprovações de movimentação"
      subtitle="Alterações salariais retroativas aguardando um segundo responsável."
      breadcrumbs={[{ label: 'Pessoas' }, { label: 'Aprovações de movimentação' }]}
    >
      {pendentes.isLoading ? (
        <p className="text-sm text-gray-500">Carregando…</p>
      ) : lista.length === 0 ? (
        <EmptyState title="Nenhuma movimentação aguardando aprovação" />
      ) : (
        <ul className="divide-y divide-gray-100 rounded-lg border border-gray-200 bg-white">
          {lista.map((m) => (
            <li key={m.id} className="flex flex-wrap items-center justify-between gap-2 px-4 py-3 text-sm">
              <div>
                <p className="font-medium text-gray-900">
                  <Link className="text-blue-700 hover:underline" to={`/pessoas/colaboradores/${m.userId}`}>{m.personName}</Link>
                  {' '}· matrícula {m.internalRegistration} · {m.typeLabel}
                </p>
                <p className="text-gray-700">
                  Efeito em {formatDate(m.effectiveDate)}
                  {m.changes.salaryAmount !== undefined ? ` · novo salário ${formatCurrency(m.changes.salaryAmount)}` : ''}
                </p>
                <p className="text-xs text-gray-500">
                  Registrada por {m.requestedByName ?? '—'} em {formatBrasilia(m.createdAt)}{m.justification ? ` · ${m.justification}` : ''}
                </p>
              </div>
              <Button size="sm" loading={aprovar.isPending} onClick={() => aprovarUma(m.id)}>Aprovar</Button>
            </li>
          ))}
        </ul>
      )}
    </PageContainer>
  );
}
